import { useEffect, useState } from "react";
import axios from "axios";
import SEO from "@/components/SEO";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import ProjectsPreview from "@/components/ProjectsPreview";
import CTASection from "@/components/CTASection";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const HomePage = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFeaturedProjects = async () => {
      try {
        const response = await axios.get(`${API}/projects?featured=true`);
        setProjects(response.data);
      } catch (error) {
        console.error("Error cargando proyectos:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFeaturedProjects();
  }, []);

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "GeneralContractor",
    "name": "Pimot Construcciones",
    "description": "Empresa líder en construcción residencial, comercial e institucional en República Dominicana desde 2021",
    "url": "https://www.pimot.com.do",
    "logo": "https://customer-assets.emergentagent.com/job_f225f10b-d8b4-4ffa-b240-0898e7a29d8d/artifacts/d1672wh9_LogoBlancoSinfondo-%20website.png",
    "telephone": "+1-829-993-0555",
    "email": "info@pimot.com.do",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "DO",
      "addressRegion": "República Dominicana"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "18.4861",
      "longitude": "-69.9312"
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "08:00",
        "closes": "18:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Saturday",
        "opens": "08:00",
        "closes": "13:00"
      }
    ],
    "priceRange": "$$",
    "areaServed": {
      "@type": "Country",
      "name": "República Dominicana"
    },
    "serviceType": ["Construcción Residencial", "Construcción Comercial", "Construcción Institucional", "Remodelaciones", "Dirección de Obra"],
    "foundingDate": "2021"
  };

  return (
    <>
      <SEO 
        title="Pimot Construcciones | Empresa de Construcción en República Dominicana"
        description="Líder en construcción residencial, comercial e institucional en República Dominicana desde 2021. Excelencia técnica, puntualidad y transparencia en cada proyecto. Contacto: 829-993-0555"
        keywords="construcción República Dominicana, construcciones RD, empresa construcción Santo Domingo, construcción residencial, construcción comercial, construcción institucional, remodelaciones, dirección de obra, Pimot Construcciones"
        url="/"
        schemaData={schemaData}
      />
      <div data-testid="home-page">
        <HeroSection />
        <AboutSection />
        <ProjectsPreview projects={projects} loading={loading} />
        <CTASection />
      </div>
    </>
  );
};

export default HomePage;